<template>
  <div class="container">
    <nav class="add-navigation">
      <div @click="$router.push({name: 'reseller-portal-customization'})" class="secondary-button">
        <!-- <secondary-button class="prev">Prev: Portal Customization</secondary-button> -->
      </div>
      <div class="buttons-wrapper">
        <div class="primary-button">
          <primary-button>Finish</primary-button>
        </div>
      </div>
    </nav>
    <div class="add-container">
      <span class="container-title">Paymeny Gateway</span>
      <div class="col-wrapper">
        <div class="col">
          <div class="payment-container">
            <div class="payment paypal active">
              <svg
                class="check-icon"
                width="24px"
                height="24px"
                viewBox="0 0 24 24"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
              >
                <g
                  id="Components-/-Field-/-Radio-/-Active"
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                >
                  <rect
                    id="Components-/-Field-/-Radio-/-Default"
                    stroke="#51A3F3"
                    stroke-width="2"
                    fill="#FFFFFF"
                    x="1"
                    y="1"
                    width="22"
                    height="22"
                    rx="11"
                  />
                  <circle id="Oval" fill="#51A3F3" cx="12" cy="12" r="7" />
                </g>
              </svg>
              <!-- <img class="check-icon"
                      src="@/assets/Icon/Radio/Default.svg"
              alt="">-->
              <img class="img-paypal" src="@/assets/paypal.png" alt />
            </div>
            <div class="payment stripe">
              <!-- <svg class="check-icon"
                    width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <g id="Components-/-Field-/-Radio-/-Active" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <rect id="Components-/-Field-/-Radio-/-Default" stroke="#51A3F3" stroke-width="2" fill="#FFFFFF" x="1" y="1" width="22" height="22" rx="11"></rect>
                        <circle id="Oval" fill="#51A3F3" cx="12" cy="12" r="7"></circle>
                    </g>
              </svg>-->
              <img class="check-icon" src="@/assets/Icon/Radio/Default.svg" alt />
              <img class="img-stripe" src="@/assets/stripe.png" alt />
            </div>
            <div class="payment mastercard">
              <!-- <svg class="check-icon"
                    width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <g id="Components-/-Field-/-Radio-/-Active" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <rect id="Components-/-Field-/-Radio-/-Default" stroke="#51A3F3" stroke-width="2" fill="#FFFFFF" x="1" y="1" width="22" height="22" rx="11"></rect>
                        <circle id="Oval" fill="#51A3F3" cx="12" cy="12" r="7"></circle>
                    </g>
              </svg>-->
              <img class="check-icon" src="@/assets/Icon/Radio/Default.svg" alt />
              <img class="img-mastercard" src="@/assets/mastercard.png" alt />
            </div>
          </div>

          <primary-input
            type="text"
            name="paypal email"
            class="field paypal-input"
            v-model="filter.text"
            v-validate="'required'"
            :class="{'input': true, 'is-danger': errors.has('paypal email')}"
            placeholder="Enter your paypal email"
          />
          <div
            class="help is-danger"
            v-if="errors.has('paypal email')"
          >{{ errors.first('paypal email') }}</div>
          <div
            class="help is-danger"
            v-if="filterError"
          >{{filterError.paypal_email ? filterError.tpaypal_emailext[0] : null}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    PrimaryInput: () => import("@/components/Inputs/PrimaryInput.vue"),
    PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
    SecondaryButton: () => import("@/components/Buttons/SecondaryButton.vue"),
    PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
  },
  data: () => ({
    filterError: null,
    type: ["None", "one or more", "all clients"],
    filter: {
      text: null,
      companies: [],
      vendors: [],
      type: null,
    },
    vendors: [],
    comapnies: [],
  }),
  created() {
    this.getVendorsList();
    this.getCompanyList();
  },
  methods: {
    getVendorsList() {
      this.$store
        .dispatch("GetVendorList", {
          nice_name: "",
        })
        .then((res) => {
          this.vendors = res.items;
          console.log("res from vendor------->", this.vendors);
        });
    },
    getCompanyList() {
      this.$store.dispatch("GetCompanyList", {}).then((res) => {
        let { total } = res;
        console.log("total--->", total);
        this.$store
          .dispatch("GetCompanyList", { perPage: total })
          .then((res) => {
            this.comapnies = res.items;
            console.log("this.companes---->", this.comapnies);
          });
      });
    },
    addfilter() {
      this.$validator.validate().then((result) => {
        if (result) {
          this.filter.companies = this.filter.companies.map((i) => {
            return { company_uuid: i.company_uuid };
          });
          this.filter.vendors = this.filter.vendors.map((i) => {
            return { vendor_uuid: i.vendor_uuid };
          });
          console.log("this.filter", this.filter);
          this.$store
            .dispatch("AddFilter", {
              filter: this.filter,
            })
            .then(() => {
              this.$snotify.success("Filter have been added.", {
                timeout: 6000,
              });
              this.$router.push({ name: "reseller-filters" });
            })
            .catch((err) => {
              if (err.errors) {
                this.filterError = err.errors[0].filter
                  ? err.errors[0].filter
                  : null;
                setTimeout(() => {
                  this.filterError = null;
                }, 6000);
              } else {
                this.$snotify.error(err.response.data.errors, {
                  timeout: 6000,
                });
              }
            });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  font-family: "Helvetica Neue";
  padding: 0 20px;
  .add-navigation {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    width: 100%;
    margin-top: 20px;
    .back-link {
      cursor: pointer;
      display: flex;
      align-items: center;
      fill: #51a3f3;
      color: #51a3f3;
      font-family: "Helvetica Neue";
      font-size: 16px;
      font-weight: 500;
      line-height: 20px;
      p {
        margin-bottom: 0;
      }
    }
    .buttons-wrapper {
      display: flex;
      align-items: center;
      width: fit-content;
      .primary-button {
        height: 40px;
        width: 110px;
      }
      .secondary-button {
        height: 40px;
        width: 90px;
        margin-right: 20px;
      }
    }
  }
  .add-container {
    flex-direction: column;
    align-items: center;
    height: 375px;
    // background-color: #FFFFFF;
    padding-top: 15px;
    .container-title {
      height: 30px;
      width: 432px;
      color: #000000;
      font-size: 16px;
      font-weight: 700;
      line-height: 30px;
      padding: 15px 0;
    }
    .col-wrapper {
      width: 60%;
      display: flex;
      justify-content: space-between;
      margin-top: 20px;
      .col {
        width: 100%;
        margin-right: 15px;
        padding: 0;
        .input {
          margin-bottom: 20px;
        }
        .field {
          p.pimary-input-title {
            color: #000000;
            font-family: "" Helvetica Neue "";
            font-size: 12px;
            font-weight: 300;
          }
        }
        .type {
          margin-top: 20px;
        }
        .pimary-input-title {
          color: #000000;
          font-family: "Helvetica Neue";
          font-size: 12px;
          font-weight: 900;
          letter-spacing: 0.21px;
          line-height: 15px;
          margin-bottom: 5px;
          text-transform: uppercase;
        }
        .payment-container {
          display: flex;
          margin-bottom: 28px;
          .payment {
            box-sizing: border-box;
            border-radius: 4px;
            background-color: #ffffff;
            margin-right: 13px;
            .check-icon {
              height: 24px;
              width: 24px;
              margin: 25px 15px 25px 17px;
            }
            .active-icon {
              // fill: #51A3F3;
              width: 24px;
              height: 24px;
              border: 2px solid #51a3f3;
              border-radius: 12px;
              background-color: #ffffff;
              padding: 5px;
            }
          }
          .paypal {
            height: 74px;
            width: 191px;
            .img-paypal {
              height: 30px;
              width: 113px;
              margin: 22px 18px 22px 0;
            }
          }
          .stripe {
            height: 70px;
            width: 159px;
            .img-stripe {
              height: 36px;
              width: 85.2px;
              margin: 16px 17.8px 18px 0;
            }
          }
          .mastercard {
            height: 70px;
            width: 122px;
            margin-right: 0px;
            .img-mastercard {
              height: 30px;
              width: 48px;
              margin: 20px 18px 20px 0;
            }
          }
          .active {
            border: 2px solid #51a3f3;
          }
        }
        .paypal-input {
          width: 498px;
        }
      }
    }
    .email-input {
      margin-bottom: 20px;
    }
    .password-input {
      margin-bottom: 30px;
    }
    .first {
      margin-bottom: 30px;
      .remember-me {
        display: flex;
        align-items: center;
        input {
          margin-right: 5px;
        }
      }
    }
  }
}
</style>

